import { useFieldArray, useFormContext } from 'react-hook-form'

import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

import { Address, City, Country, PostalCode, State } from './fields'

export const AddressFields = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo.${index as 0}.addressesInfo`
  })

  return (
    <>
      {fields.map((field, index2) => (
        <AddressItem index1={index} index2={index2} key={field.id} rowsNumber={fields.length} onDelete={remove} />
      ))}

      <IconButton
        icon={IconName.ADD_GREEN}
        onClick={() => append({ address: '', city: '', country: '', postalCode: '', state: '' })}
      />
    </>
  )
}

const AddressItem = ({
  index1,
  index2,
  rowsNumber,
  onDelete
}: {
  index1: number
  index2: number
  rowsNumber: number
  onDelete: (index: number) => void
}) => {
  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => onDelete(index2),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <div style={{ marginBottom: '15px' }}>
      <Confirmation />
      <FormRow>
        <Col>
          <h5>Subject Address Information</h5>
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <Address index1={index1} index2={index2} />
        </Col>
        <Col>
          <City index1={index1} index2={index2} />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <State index1={index1} index2={index2} />
        </Col>
        <Col>
          <PostalCode index1={index1} index2={index2} />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <Country index1={index1} index2={index2} />
        </Col>
        {rowsNumber > 1 && <IconButton face="negative" icon={IconName.DELETE} onClick={startDeleting} />}
      </FormRow>
    </div>
  )
}
